import { render, staticRenderFns } from "./o-featured-article.vue?vue&type=template&id=66e2211a&scoped=true"
import script from "./o-featured-article.vue?vue&type=script&lang=js"
export * from "./o-featured-article.vue?vue&type=script&lang=js"
import style0 from "./o-featured-article.vue?vue&type=style&index=0&id=66e2211a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e2211a",
  null
  
)

export default component.exports